import { InjectionToken } from '@angular/core';

export const AppConfigurationProvider = new InjectionToken<AppConfiguration>(
  'Injection token for configuration object'
);

export interface AppConfiguration {
  api_url: string;
  pasfoto_api_url: string;
  api_subscription_key: string;
  api_version: string;
  redirect_url: string;
  relay42_config: { preview: boolean; nsenvironment: string; language: string };
}
